<app-header-navigation-bar></app-header-navigation-bar>
<div class="home-onlygal">
    <app-quick-actions    [userName]="userName" [actions]="quickActions" [showQuickActions]="showDirectAreas"></app-quick-actions>
    <app-cases            [expedientes]="expedientes" [loading]="loadingExpedientes"></app-cases>
    <app-consultas        [consultas]="consultasLegales" [loading]="loadingConsultas" *ngIf="showDirectAreas && hasLegalPolicies"></app-consultas>
    <app-promo            *ngIf="showDirectAreas && hasLegalPolicies"></app-promo>
    <app-active-products  [productos]="productosActivos" [loading]="loadingProductos" *ngIf="showDirectAreas"></app-active-products>
    <app-benefits         *ngIf="showBenefits"></app-benefits>
    <app-other-insurance  [seguros]="otherInsurances" subtitulo="Seguros onLygal recomendados para ti" footer="Para contratar otro producto onLygal consulta con tu mediador de seguros." *ngIf="showDirectAreas"></app-other-insurance>
    <app-articles *ngIf="showCategoria"></app-articles>
</div>
<app-footer></app-footer>
